import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { sentryDsn } from '../api'

const enableSentry = process.env.NODE_ENV === 'production'
if (enableSentry) {
  Sentry.init({
    Vue,
    dsn: sentryDsn,
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing()
    ],
    beforeSend (event) {
      console.error(event.exception.values[0].value)
      return event
    }
  })

  console.log('Sentry is enabled')
} else {
  console.log('Sentry is disabled')
}
